import { render, staticRenderFns } from "./ClientContracts.vue?vue&type=template&id=3d8b6ed5"
import script from "./ClientContracts.vue?vue&type=script&lang=js"
export * from "./ClientContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports